import React from 'react';
import { Button } from './ui/button';
import { Phone, Mail } from 'lucide-react';
import { COMPANY } from '../data/company';

export const CalloutBanner = () => {
  return (
    <section id="contact" className="py-16 bg-gradient-to-r from-orange-600 to-orange-700 relative overflow-hidden">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Need a Load Today?
        </h2>
        <p className="text-xl text-orange-100 mb-8 max-w-2xl mx-auto">
          Don't wait for tomorrow's opportunities. Get connected with high-paying loads right now.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button size="lg" onClick={() => (window.location.href = COMPANY.phoneHref)} className="bg-white text-orange-600 hover:bg-orange-50 text-lg px-8 py-4 flex items-center gap-2 shadow-xl" data-testid="callout-phone-btn">
            <Phone className="h-5 w-5" />
            Call {COMPANY.phoneDisplay}
          </Button>
          <Button size="lg" variant="outline" onClick={() => (window.location.href = `mailto:${COMPANY.email}`)} className="border-white text-white hover:bg-white hover:text-orange-600 text-lg px-8 py-4 flex items-center gap-2" data-testid="callout-email-btn">
            <Mail className="h-5 w-5" />
            {COMPANY.email}
          </Button>
        </div>
      </div>
    </section>
  );
};